var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNatureOfBusinessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6719 18.7516H4.83435C4.37389 18.7508 4.00083 18.3777 4 17.9172V17.2405C4.00577 15.3145 5.56604 13.7549 7.49195 13.75H13.0143C14.9402 13.7549 16.5004 15.3145 16.5062 17.2405V17.9172C16.5054 18.3777 16.1323 18.7508 15.6719 18.7516Z",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2514 10.4989C8.38841 10.4989 6.87748 8.98997 6.875 7.127C6.87253 5.26402 8.37945 3.75108 10.2424 3.74611C12.1054 3.74116 13.6203 5.24605 13.6278 7.10901C13.6306 8.00658 13.2762 8.86839 12.6428 9.50434C12.0093 10.1403 11.149 10.4981 10.2514 10.4989Z",
    fill: "#3158F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.26501,
    y: 8.55859,
    width: 15.3605,
    height: 10.2403,
    fill: "#3158F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6869 19.4987V8.59286C17.6869 8.17267 17.3463 7.83203 16.9261 7.83203H13.5203",
    fill: "#3158F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6869 19.4987V8.59286C17.6869 8.17267 17.3463 7.83203 16.9261 7.83203H13.5203",
    stroke: "#3158F2",
    strokeWidth: 1.49938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85246 7.83203H3.44662C3.02643 7.83203 2.68579 8.17267 2.68579 8.59286V19.4987",
    fill: "#3158F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85246 7.83203H3.44662C3.02643 7.83203 2.68579 8.17267 2.68579 8.59286V19.4987",
    stroke: "#3158F2",
    strokeWidth: 1.49938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5203 10.3327H15.6036",
    stroke: "white",
    strokeWidth: 1.49938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5203 12.8327H15.6036",
    stroke: "white",
    strokeWidth: 1.49938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5203 15.3307H15.6036",
    stroke: "white",
    strokeWidth: 1.49938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77344 10.3327H6.85677",
    stroke: "white",
    strokeWidth: 1.49938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77344 12.8327H6.85677",
    stroke: "white",
    strokeWidth: 1.49938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77344 15.3307H6.85677",
    stroke: "white",
    strokeWidth: 1.49938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5231 19.5007H1.85645",
    stroke: "#3158F2",
    strokeWidth: 1.49938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85291 19.5V5.33333C6.85291 4.8731 7.226 4.5 7.68624 4.5H12.6862C13.1465 4.5 13.5196 4.8731 13.5196 5.33333V19.5",
    fill: "#3158F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85291 19.5V5.33333C6.85291 4.8731 7.226 4.5 7.68624 4.5H12.6862C13.1465 4.5 13.5196 4.8731 13.5196 5.33333V19.5",
    stroke: "#3158F2",
    strokeWidth: 1.49938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9364 12.8327H11.4364",
    stroke: "white",
    strokeWidth: 1.49938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9364 15.3307H11.4364",
    stroke: "white",
    strokeWidth: 1.49938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9364 10.3327H11.4364",
    stroke: "white",
    strokeWidth: 1.49938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9364 7.83268H11.4364",
    stroke: "white",
    strokeWidth: 1.49938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0146 18.6667L9.34798 18.6667",
    stroke: "white",
    strokeWidth: 1.49938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNatureOfBusinessCheck);
export default __webpack_public_path__ + "static/media/nature_of_business_check.87a72d3fd8441cf7bf2494768b4ded32.svg";
export { ForwardRef as ReactComponent };